export default "__VITE_ASSET__10190276__"